const B_1 = [
    {
        title: '添加中标公告',
        path: '/bidding/projectflow/dingbiao/zhongbiaogg/zfcg/list'
    }
]
export default {
    path: 'zfcg',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-dingbiao-zhongbiaogg-zfcg'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/zfcg/list'),
            meta: {
                title: '添加中标公告列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/zfcg/form'),
            meta: {
                title: '添加/修改中标公告',
                bread: '/bidding/projectflow/dingbiao/zhongbiaogg/zfcg/form'
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/zfcg/detail'),
            meta: {
                title: '查看中标公告',
                bread: '/bidding/projectflow/dingbiao/zhongbiaogg/zfcg/show'
            },
        },
        {
            path:"halfForm",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/zfcg/half/form'),
            meta: {
                title: '添加/修改中标公告',
                bread: '/bidding/projectflow/dingbiao/zhongbiaogg/zfcg/half/form'
            },
        }        
    ]
}